const mInitialAccess = {
  mInitialAccess: {
    accessAcademy: {
      first: {
        click: 'haciendo click aquí',
        link: 'acceder a academia',
        select: 'O puedes acceder a la academia'
      },
      second: 'O puedes seleccionar una de tus academias para acceder:',
      third: 'selecciona la academia a la que deseas acceder:'
    },
    activeLicense: 'Licencia activa desde',
    availableLicense: {
      first: 'tienes disponible una licencia activa desde',
      link: 'activar licencia',
      second: 'si deseas comenzar a utilizarla haz click aquí'
    },
    availableLicenses: 'tienes disponibles las siguientes licencias activas, selecciona una para comenzar a utilizarla',
    greeting: 'Hola',
    message: 'Accediendo a Vidroop'
  }
}

export default mInitialAccess
